// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu_menu__3Ct8z","menu_item":"menu_menu_item__3_H8D"};